export default "__VITE_ASSET__CAeGSdqN__"